export enum IDocumentTypeMapping {
    FoaieObservatie = 1,
    FisaSpitalizareZi = 5,
    FisaPrezentareUrgenta = 6,
    BiletTrimitere = 8,
    Retete = 9,
    CertificateMedicale = 11,
    FisaConsultatie = 12,
    CerereAnalizeLIMS = 31,
    FisaMM = 21,
    FisaPortArma = 57,
    FisaAuto = 59,
    FisaARR = 60,
    FisaReavizarePortArma = 61,
    FisaCertificatMedical = 62,
    FisaAmbarcatiuni = 74
}
